import React from "react";
export const PageSetup = React.createContext();
